import { apiClient } from '@/shared/lib/api/client';
import type {
  DefinirSenhaPreview,
  EscolaAtivaRequest,
  LoginRequest,
  MeResponse,
  TokenResponse,
} from '@/types/api';

export const authService = {
  login: async (payload: LoginRequest): Promise<TokenResponse> => {
    const { data } = await apiClient.post<TokenResponse>('/v1/auth/login', payload);
    return data;
  },

  me: async (): Promise<MeResponse> => {
    const { data } = await apiClient.get<MeResponse>('/v1/auth/me');
    return data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/v1/auth/logout');
  },

  selecionarEscola: async (payload: EscolaAtivaRequest): Promise<void> => {
    await apiClient.put('/v1/auth/escola-ativa', payload);
  },

  salvarAtalhos: async (codigos: number[]): Promise<void> => {
    await apiClient.put('/v1/auth/atalhos', { codigos });
  },

  esqueciSenha: async (login: string): Promise<void> => {
    await apiClient.post('/v1/auth/esqueci-senha', { login });
  },

  consultarTokenSenha: async (token: string): Promise<DefinirSenhaPreview> => {
    const { data } = await apiClient.get<DefinirSenhaPreview>('/v1/auth/definir-senha', {
      params: { token },
    });
    return data;
  },

  definirSenha: async (token: string, senha: string): Promise<void> => {
    await apiClient.post('/v1/auth/definir-senha', { token, senha });
  },
};
